module.exports = __webpack_public_path__ + "assets/images/01Box.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01Box.png
// module id = 1253
// module chunks = 1